import { render, staticRenderFns } from "./Editdentitydocument.vue?vue&type=template&id=559f66ef&scoped=true&"
import script from "./Editdentitydocument.vue?vue&type=script&lang=js&"
export * from "./Editdentitydocument.vue?vue&type=script&lang=js&"
import style0 from "./Editdentitydocument.vue?vue&type=style&index=0&id=559f66ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f66ef",
  null
  
)

export default component.exports